<template>
  <div :id="this.id" class="h100"></div>
</template>

<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    id: Number,
    // color: String,
    detaildata: Array,
    xAxisdata: Array,
    title: String,
    color: String
  },
  mounted() {
    // console.log(this.detaildata,this.xAxisdata);
    this.drawLine(this.id, this.detaildata);
    this.chartAuto();
  },
  watch: {
    detaildata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.drawLine(this.id, newQuestion);
        });
      },
      deep: true
    },
    xAxisdata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.xAxisdata = newQuestion;
        });
      },
      deep: true
    }
  },
  methods: {
    drawLine(id, bardata) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(id));
      // 绘制图表
      let option = {
        grid: {
          left: "7%",
          right: "7%",
          bottom: "0%",
          containLabel: true
        },
        xAxis: {
          data: this.xAxisdata,
          axisLine: {
            lineStyle: {
              color: "#b3d6ff"
            }
          },
          axisLabel: {
            interval: 0,
            rotate:20,
            color: "#b0b5c4",
            fontSize: 12
          },
          axisTick:{
            show:false
          }
        },
        yAxis: {
          axisLine: {
            show:false,
            lineStyle: {
              color: "#eaeef3"
            }
          },
          axisLabel: {
            show:false,
            color: "#777777",
            fontSize: 14
          },
          axisTick:{
            show:false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#eaeef3"
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: 15,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#b8aeff"
                    },
                    {
                      offset: 1,
                      color: "#786fe4"
                    }
                  ],
                  false
                )
              }
            },
            label: {
              normal: {
                show: true,
                fontSize: 12,
                color: "#777777",
                position: "top"
              }
            },
            data: bardata
          }
        ]
      };

      myChart.setOption(option);
    },
    chartAuto() {
      let myChart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/normalbar.vue